import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Container from '~/components/ui/Container';
import Panel from '~/components/ui/Panel';
import CompanyPartnershipLogo from './CompanyPartnershipLogo';

type CompanyBannerProps = {
  partnerText?: string;
};

const CompanyPartnership: React.FC<CompanyBannerProps> = ({ partnerText }) => {
  return (
    <Container className="relative z-10 -mt-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6">
        <Panel
          className="border-blue-300 bg-blue-25 lg:col-span-12"
          variant="collapsed"
          position="last"
        >
          <Panel.Content>
            <h2 className="mb-5 flex items-center gap-3 font-avantgarde text-xl font-bold text-blue-600 lg:text-2xl">
              <FontAwesomeIcon
                icon={faShieldCheck as IconProp}
                className="text-3xl text-blue-500"
              />
              <span>Samenwerking met Advieskeuze</span>
            </h2>
            {partnerText}
          </Panel.Content>
          <Panel.Sidebar className="flex items-center justify-center">
            <CompanyPartnershipLogo />
          </Panel.Sidebar>
        </Panel>
      </div>
    </Container>
  );
};

export default CompanyPartnership;
